'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');

var _services = require('../../services');
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _CellPhotoBlock = require('../../components/OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock');var _CellPhotoBlock2 = _interopRequireDefault(_CellPhotoBlock);
var _getLocalizedData4 = require('../../utils/getLocalizedData');var _getLocalizedData5 = _interopRequireDefault(_getLocalizedData4);
var _formatCurrency = require('../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _constants = require('../../constants');

var _ForeignProject = require('./ForeignProject.scss');var styles = _interopRequireWildcard(_ForeignProject);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ForeignProject = function (_Component) {_inherits(ForeignProject, _Component);function ForeignProject() {var _temp, _this, _ret;_classCallCheck(this, ForeignProject);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    openDetails = function (evt, propertyId) {
      var location = 'project_details';
      var entityType = 'project';
      var route = (0, _appendLocale2.default)(
      _this.props.locale, '/' +
      location + '/' + propertyId);


      if (evt.ctrlKey || evt.metaKey) {
        window.open(route);
      } else if (_this.props.isMobile) {
        _reactRouter.browserHistory.push(route);
      } else {
        _this.props.openDetailsPopup({ propertyId: propertyId, entityType: entityType });
      }

      _services.AnalyticsEventService.createPropertyEvent({ propertyId: propertyId, action: _constants.analyticsEventAction.VIEW });
    }, _this.

    renderImages = function () {var _this$props =

      _this.props,isMobile = _this$props.isMobile,translate = _this$props.translate,locale = _this$props.locale,isRtl = _this$props.isRtl,exactPrice = _this$props.exactPrice,minPrice = _this$props.minPrice,currency = _this$props.currency,isProjectSlider = _this$props.isProjectSlider,isFavorite = _this$props.isFavorite,toggleFavorite = _this$props.toggleFavorite;
      var image = (0, _get2.default)(_this.props, 'images[0]') || null;

      var isDefaultLanguage = locale === _constants.language.default;
      var priceLocalizationKey = isMobile || !isDefaultLanguage ? 'from' : 'startingFrom';
      var separator = isMobile ? ' ' : ' - ';
      var nis = (0, _formatCurrency2.default)(currency);
      var ltrSymbol = String.fromCharCode(8206);

      var images = [];
      var formattedPrice = exactPrice ? '' +
      ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
      translate(priceLocalizationKey) + separator + nis + (0, _beautifyNumber2.default)(minPrice);

      _this.props.images.forEach(function (element) {
        images.push({ thumbnail: element });
      });

      var param = {
        className: isMobile ? 'foreignPropertyCellPhotoBlockModile' : 'foreignPropertyCellPhotoBlock',
        withoutPagination: isMobile,
        withoutPrice: !isMobile && !isProjectSlider,
        price: formattedPrice,
        withoutLoop: true,
        withoutCurrency: true,
        withoutRealEstateSlider: true,
        photo: image,
        translate: translate,
        locale: locale,
        images: images,
        isRtl: isRtl,
        isFavorite: isFavorite,
        toggleFavorite: toggleFavorite };


      if (isProjectSlider) {
        return (
          _react2.default.createElement(_CellPhotoBlock2.default, _extends({},
          param, {
            className: isMobile ? 'homePageSliderPhoto' : 'foreignCellPhotoBlock' })));


      }

      return (
        _react2.default.createElement('div', { className: styles.photoBlockWrapper },
          _react2.default.createElement(_CellPhotoBlock2.default, _extends({},
          param, {
            classNameProperty: isMobile && 'foreignProperties' }))));



    }, _this.

    renderProject = function () {var _cx;var _this$props2 =
      _this.props,translate = _this$props2.translate,locale = _this$props2.locale,id = _this$props2.id,exactPrice = _this$props2.exactPrice,minPrice = _this$props2.minPrice,isMobile = _this$props2.isMobile,currency = _this$props2.currency,isProjectSlider = _this$props2.isProjectSlider;

      var statusLocaliseData = _constants.projectStatuses.find(function (item) {return item.name === _this.props.status;}) || {};var _getLocalizedData =

      (0, _getLocalizedData5.default)(_this.props.name, locale),name = _getLocalizedData.result;var _getLocalizedData2 =





      (0, _getLocalizedData5.default)(_this.props.address, locale, true),_getLocalizedData2$re = _getLocalizedData2.result,street_name = _getLocalizedData2$re.street_name,house_number = _getLocalizedData2$re.house_number,city_name = _getLocalizedData2$re.city_name,country_name = _getLocalizedData2$re.country_name;var _getLocalizedData3 =
      (0, _getLocalizedData5.default)(statusLocaliseData.localisation, locale),status = _getLocalizedData3.result;

      var isDefaultLanguage = locale === _constants.language.default;
      var priceLocalizationKey = isMobile || !isDefaultLanguage ? 'from' : 'startingFrom';
      var separator = isMobile ? ' ' : ' - ';
      var nis = (0, _formatCurrency2.default)(currency);
      var ltrSymbol = String.fromCharCode(8206);

      var formattedPrice = exactPrice ? '' +
      ltrSymbol + nis + ' ' + (0, _beautifyNumber2.default)(exactPrice) : '' +
      translate(priceLocalizationKey) + separator + nis + ' ' + (0, _beautifyNumber2.default)(minPrice);

      var handleClick = function handleClick(evt) {return _this.openDetails(evt, id);};

      return (
        _react2.default.createElement('div', {
            key: id,
            onClick: handleClick,
            className: (0, _classnames2.default)(
            styles.project, (_cx = {}, _cx[
            styles.projectSliderWrapper] = isProjectSlider, _cx)) },


          _this.renderImages(),
          _react2.default.createElement('div', { className: styles.descriptionSection },
            !isMobile && !isProjectSlider && _react2.default.createElement('div', { className: 'priceForeignCountry' }, formattedPrice),
            _react2.default.createElement('div', { className: styles.name }, name),
            _react2.default.createElement('div', null, street_name && street_name, '\xA0', house_number && house_number, ','),
            _react2.default.createElement('div', null, city_name && city_name),
            _react2.default.createElement('div', null, country_name && country_name),
            _react2.default.createElement('div', { className: styles.status }, _react2.default.createElement('b', null, _this.props.translate('status'), ':\xA0'), status))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}ForeignProject.prototype.

  render = function render() {
    return this.renderProject();
  };return ForeignProject;}(_react.Component);


ForeignProject.propTypes = {
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  exactPrice: _propTypes2.default.number,
  minPrice: _propTypes2.default.number,
  images: _propTypes2.default.array,
  id: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  name: _propTypes2.default.object,
  summary: _propTypes2.default.object,
  address: _propTypes2.default.object,
  status: _propTypes2.default.object,
  isProjectSlider: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func.isRequired,
  isFavorite: _propTypes2.default.bool.isRequired,
  openDetailsPopup: _propTypes2.default.func };exports.default =


ForeignProject;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignProject/ForeignProject.js
// module id = 558
// module chunks = 0